// extracted by mini-css-extract-plugin
export default {"card":"blocker-router-modal_card__-ju8Q","title":"blocker-router-modal_title__55BQA","text":"blocker-router-modal_text__G-71w","btns":"blocker-router-modal_btns__AiDA0"};